import type { CustomerModel } from '@/types/models/CustomerModel'

export type CustomerState = {
    customers: CustomerModel[]
    customer?: CustomerModel
}

export enum ECustomerActions {
    FETCH_CUSTOMERS = 'fetchCustomers',
    FETCH_CUSTOMER = 'fetchCustomer',
    CREATE_CUSTOMER = 'createCustomer',
    UPDATE_CUSTOMER = 'updateCustomer',
    DELETE_CUSTOMER = 'deleteCustomer',
    RESET_CUSTOMER = 'resetCustomer'
}

export enum ECustomerMutations {
    SET_CUSTOMERS = 'setCustomers',
    SET_CUSTOMER = 'setCustomer',
    SET_LOADING = 'setLoading',
    SET_PAGINATION = 'setPagination',
    REMOVE_CUSTOMER = 'removeCustomer',
    RESET_CUSTOMER = 'resetCustomer'
}
